import { render } from "./formContact.vue?vue&type=template&id=dcbf2558&scoped=true&lang=html"
import script from "./formContact.vue?vue&type=script&lang=js"
export * from "./formContact.vue?vue&type=script&lang=js"

import "./formContact.vue?vue&type=style&index=0&id=dcbf2558&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcbf2558"]])

export default __exports__